import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto max-w-page px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-primary-950 text-lg" />
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">国语对白做受69</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed max-w-md">
              国语对白做受69 是聚焦国语对白相关影音资源的综合内容站点，提供影视作品的分类浏览、资料介绍与关联推荐，
              帮助中文用户更便捷地查询和了解多样影音作品。
            </p>
            <p className="mt-4 text-xs text-background-400 max-w-md leading-relaxed">
              本站为演示性质的内容展示平台，所有内容仅用于介绍与浏览，不提供播放、下载、会员及支付服务。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">分类导航</h3>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">站点信息</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  搜索资源
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  意见反馈
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">© 2026 国语对白做受69 · 高清影音资源集锦</p>
          <p className="text-xs text-background-400">内容仅作展示与介绍 · 本站为演示项目</p>
        </div>
      </div>
    </footer>
  );
}